<template>
  <div>
    <!-- 詢價需求單查詢 -->
    <CCard>
      <CCardBody>
        <SearchBar
          :finishInvalidCount="finishInvalidCount"
          @doSearchEvent="doSearchEvent"
        ></SearchBar>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
        <div class="table-container">
          <vue-bootstrap4-table
            ref="requestSearchBs4Table"
            class=""
            :rows="rows"
            :columns="columns"
            @on-change-query="onChangeQuery"
            :total-rows="totalCount"
            :config="config"
            :classes="classes"
          >
            <template v-if="isTw" slot="empty-results"> 查無結果 </template>
            <template v-if="isTw" slot="pagination-info" slot-scope="props">
              {{ paginationInfoTwText(props) }}
            </template>
            <template slot="func" slot-scope="props">
              <!-- 編輯 -->
              <button
                class="btn btn-sm btn-success mr-2"
                @click="detail('edit', props.row)"
              >
                {{ i18n("Buttons.DetailInfo") }}
              </button>
              <!-- 退件 -->
              <button
                class="btn btn-sm btn-danger mr-2"
                data-toggle="modal"
                data-target="#rejectModal"
                @click="setReject(props.row.id)"
                v-if="isCaseReject(props.row)"
              >
                {{ i18n("Buttons.Reject") }}
              </button>
              <!-- 複製 -->
              <button
                class="btn btn-sm btn-info mr-2"
                @click="detail('copy', props.row)"
                v-if="props.row.highestVersion === props.row.version"
              >
                {{ i18n("Buttons.CopyData") }}
              </button>
              <!-- 重啟報價 -->
              <button
                class="btn btn-sm btn-warning mr-2"
                @click="restartRequest(props.row.id)"
                v-if="
                  props.row.status === '廠商報價中' &&
                  props.row.purchase === $userInfo.account
                "
              >
                {{ i18n("Buttons.RestartQuotation") }}
              </button>
              <!-- 作廢 -->
              <button
                class="btn btn-sm btn-danger mr-2"
                data-toggle="modal"
                data-target="#deleteModal"
                @click="setInvalidId(props.row.id)"
                v-if="isCaseInvalid(props.row)"
              >
                {{ i18n("Buttons.Invalid") }}
              </button>
              <!-- 指定結案 -->
              <button
                class="btn btn-sm btn-primary mr-2"
                @click="closeCase(props.row.id)"
                v-if="
                  props.row.purchase === $userInfo.account &&
                  props.row.status === '廠商報價中'
                "
              >
                {{ i18n("Buttons.SettingCloseCase") }}
              </button>
              <!-- 採購擔當變更 -->
              <button
                class="btn btn-sm btn-purple mr-2"
                @click="openChangesInPurchasingResponsibilityModal(props.row)"
                v-if="
                  (isAdmin || isPurchaserSuperior || isRequestOnly) &&
                  (props.row.status === '需求單位已確認' || props.row.status === '採購單位處理中')
                "
              >
                {{ i18n("Request_Vue.ChangesInPurchasingResponsibility") }}
              </button>
              <!-- 詢價家數變更 -->
              <button
                class="btn btn-sm btn-purple mr-2"
                v-if="
                  (isAdmin || isPurchaserSuperior || isRequestOnly) &&
                  props.row.status === '廠商報價中'
                "
                @click="openChangesNumberOfInquiriesModal(props.row)"
              >
                {{ i18n("Request_Vue.ChangesInTheNumberOfInquiries") }}
              </button>
              <!-- 需求附件 -->
              <button
                class="btn btn-sm btn-warning mr-2"
                @click="requireFileModal(props.row.id)"
                v-if="props.row.status !== '需求單位開立中'"
              >
                {{ i18n("Request_Vue.RequirementsFile") }}
              </button>
              <!-- 採購例外備註附件 -->
              <button
                class="btn btn-sm btn-info mr-2"
                @click="openPurchaseExceptionRemarks(props.row)"
                v-if="
                  isAdmin || 
                  isPurchaserSuperior ||
                  isAuditSuperior ||
                  isRequestOnly || 
                  props.row.purchase === $userInfo.account ||
                  isPurchaser
                "
              >
                {{ i18n("Request_Vue.PurchaseExceptionRemarks") }}
              </button>
              <!-- 廠商附件 -->
              <button
                class="btn btn-sm btn-warning mr-2"
                @click="VendorFileModal(props.row.id)"
                v-if="
                  (props.row.status === '結案' ||
                    props.row.status === '指定結案') &&
                  isPurchase
                "
              >
                {{ i18n("Request_Vue.ManufacturerFile") }}
              </button>
            </template>
          </vue-bootstrap4-table>
        </div>
      </CCardBody>
    </CCard>

    <RejectModal @finishReject="finishReject" />
    <DeleteModal @finishInvalid="finishInvalid" />

    <!-- 需求附件 Modal -->
    <div
      class="modal fade"
      id="requireFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("Request_Vue.RequirementsFile") }}
          </div>
          <div class="modal-body">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th
                    class="text-center"
                    v-for="header in requireFileTableHeader"
                    :key="header"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in requireFileList" :key="item.id">
                  <td class="text-center">{{ item.index }}</td>
                  <td class="text-center">{{ item.productName }}</td>
                  <td class="text-center">{{ item.spec }}</td>
                  <td class="text-center">{{ item.brand }}</td>
                  <td class="text-center">{{ item.productNo }}</td>
                  <td class="text-center">{{ item.fileIndex }}</td>
                  <td class="text-center">{{ item.fileName }}</td>
                  <td class="text-center fileDownload">
                    <a @click="downloadRequireFile(item.id)">下載</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 廠商附件 Modal -->
    <div
      class="modal fade"
      id="VendorFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("Request_Vue.ManufacturerFile") }}
          </div>
          <div class="modal-body">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th
                    class="text-center"
                    v-for="header in VendorFileTableHeader"
                    :key="header"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in vendorFileList" :key="item.id">
                  <td class="text-center">{{ item.supplierSeq }}</td>
                  <td class="text-center">{{ item.vendorId }}</td>
                  <td class="text-center">
                    {{ item.vendorAbbreviation }}
                  </td>
                  <td class="text-center">{{ item.attachFileSeq }}</td>
                  <td class="text-center">{{ item.fileName }}</td>
                  <td class="text-center fileDownload">
                    <a @click="downloadVendorFile(item.id)">下載</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 採購例外備註 Modal -->
    <div
      class="modal fade"
      id="purchaseExceptionRemarksModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("Request_Vue.PurchaseExceptionRemarks") }}
          </div>
          <div class="modal-body">
            <textarea
              style="width: 100%;"
              maxlength="400"
              rows="3"
              v-model="tempRow.purchaseExceptionMemo"
              :disabled="tempRow.purchase !== $userInfo.account"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>

            <button v-if="tempRow.purchase === $userInfo.account" type="button" class="btn btn-blue" @click.prevent="savePurchaseExceptionRemarks">{{$t('Buttons.SavedData')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 採購擔當變更 Modal -->
    <div
      class="modal fade"
      id="changesInPurchasingResponsibilityModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("Request_Vue.ChangesInPurchasingResponsibility") }}
          </div>
          <div class="modal-body">
            <Select2
              style="width: 100%"
              class="purchase_input"
              v-model="tempRow.purchase"
              :options="FactoryPurchase"
              :settings="{
                multiple: false,
                width: '100%',
                allowClear: true,
              }"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>

            <button type="button" class="btn btn-blue" @click.prevent="saveChangesInPurchasingResponsibility">{{$t('Buttons.SavedData')}}</button>
          </div>
        </div>
      </div>
    </div>

    
    <!-- 詢價家數變更 Modal -->
    <div
      class="modal fade"
      id="changesNumberOfInquiriesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("Request_Vue.ChangesInTheNumberOfInquiries") }}
          </div>
          <div class="modal-body">
            <div :class="requiredCss('ask_merchant')">
              <p>{{ $t("Request_Vue.AskMerchant") }}：</p>
              <div
                v-for="(item, key) in merchantList"
                :key="'askMerchant_input_' + key"
              >
                <input
                  type="radio"
                  name="askMerchant_input"
                  v-model="tempRow.inquiryCount"
                  :value="item.askMerchantId"
                />{{ item.askMerchantCaption }}
              </div>
              <div v-if="tempRow.inquiryCount === false">
                <span>，{{ $t("Request_Vue.AskMerchantReason") }}：</span>
                <input
                  type="text"
                  maxlength="400"
                  style="width: 500px"
                  v-model="tempRow.inquiryCountReason"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>

            <button type="button" class="btn btn-blue" @click.prevent="saveChangesNumberOfInquiries">{{$t('Buttons.SavedData')}}</button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import $ from "jquery";
import SearchBar from "./SearchBar";
import DeleteModal from "./DeleteModal";
import RejectModal from "./RejectModal";
import { mapActions, mapGetters } from "vuex";
import { Notification } from "element-ui";
import { requestMixin } from '@/mixin/request'

export default {
  mixins: [requestMixin],
  components: {
    SearchBar,
    DeleteModal,
    RejectModal,
  },
  data() {
    return {
      rows: [],
      totalCount: 0,
      filter: { pageSize: 10, pageIndex: 1 },
      requestQueryParam: {},
      columns: [
        {
          label: this.i18n("Request_Vue.FactoryType"),
          name: "factoryName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.StartDate"),
          name: "createTime",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Applicant"),
          name: "applicantName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.ApplicantDept"),
          name: "applicantDept",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.QuoteNo"),
          name: "inquiryNo",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Version"),
          name: "version",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.InquiryName"),
          name: "inquiryName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Purchaser"),
          name: "purchaseName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Status"),
          name: "status",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.VoidReason"),
          name: "voidReason",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.isPR"),
          name: "isPR",
          row_text_alignment: "text-left",
        },
        { label: this.i18n("Request_Vue.Function"), name: "func" },
      ],
      config: {
        card_mode: false,
        show_refresh_button: false,
        show_reset_button: false,
        server_mode: true, // by default false
        per_page: 10, // default 10
        per_page_options: [10, 25, 50],
        global_search: {
          visibility: false,
        },
      },
      classes: {},
      finishInvalidCount: 0,

      requireFileTableHeader: [
        // 需求附件表格標題
        this.i18n("Request_Vue.RequirementsIndex"),
        this.i18n("Request_Vue.ProductName"),
        this.i18n("Request_Vue.Specification"),
        this.i18n("Request_Vue.Brand"),
        this.i18n("Request_Vue.Type"),
        this.i18n("Request_Vue.FileIndex"),
        this.i18n("Request_Vue.FileName"),
        this.i18n("Request_Vue.Download"),
      ],

      VendorFileTableHeader: [
        // 廠商附件表格標題
        this.i18n("Request_Vue.ManufacturerIndex"),
        this.i18n("Request_Vue.QuotationManufacturer"),
        this.i18n("Request_Vue.QuotationManufacturerName"),
        this.i18n("Request_Vue.FileIndex"),
        this.i18n("Request_Vue.FileName"),
        this.i18n("Request_Vue.Download"),
      ],

      requireFileList: [], // 需求附件
      vendorFileList: [], // 廠商附件

      isPurchase: null, // 是否為採購身分(所有採購)

      tempRow: {
        purchaseExceptionMemo: null,
        inquiryCount: null,
      },

      FactoryPurchase: [],
      merchantList: this.$t("merchantList"), // 詢價家數 清單
    };
  },
  props: {},
  watch: {
    lang: function () {
      (this.columns = [
        {
          label: this.i18n("Request_Vue.FactoryType"),
          name: "factory",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.StartDate"),
          name: "createTime",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Applicant"),
          name: "applicantName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.ApplicantDept"),
          name: "applicantDept",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.QuoteNo"),
          name: "inquiryNo",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Version"),
          name: "version",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.InquiryName"),
          name: "inquiryName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Purchaser"),
          name: "purchaseName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Status"),
          name: "status",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.VoidReason"),
          name: "voidReason",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.isPR"),
          name: "isPR",
          row_text_alignment: "text-left",
        },
        { label: this.i18n("Request_Vue.Function"), name: "func" },
      ]),
        (this.VendorFileTableHeader = [
          // 廠商附件表格標題
          this.i18n("Request_Vue.ManufacturerIndex"),
          this.i18n("Request_Vue.QuotationManufacturer"),
          this.i18n("Request_Vue.QuotationManufacturerName"),
          this.i18n("Request_Vue.FileIndex"),
          this.i18n("Request_Vue.FileName"),
          this.i18n("Request_Vue.Download"),
        ]),
        (this.requireFileTableHeader = [
          // 需求附件表格標題
          this.i18n("Request_Vue.RequirementsIndex"),
          this.i18n("Request_Vue.ProductName"),
          this.i18n("Request_Vue.Specification"),
          this.i18n("Request_Vue.Brand"),
          this.i18n("Request_Vue.Type"),
          this.i18n("Request_Vue.FileName"),
          this.i18n("Request_Vue.Download"),
        ]);
    },
  },
  methods: {
    ...mapActions("requestModule", ["searchRequest"]),

    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 查詢 詢價需求單 Api
    doSearchEvent(val) {
      const $fixDate = this.fixDate;

      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestMasterPage`;
      let params = { ...val };

      this.searchRequest(params);

      this.updateLoading(true);

      this.axios.get(api, { params }).then((response) => {
        // console.log("詢價需求單列表", response);

        if (response.status === 200) {
          this.updateLoading(false);
          if (response.data.errorMessage) {
            Notification({
              title: "失敗",
              message: response.data.errorMessage,
              type: "error",
              duration: 5000,
            });
          } else {
            // vm.rows = response.data;
            vm.rows = response.data.rows.map((item) => {
              let factoryName = "";
              if (item.factoryId === "KH" || item.factoryId === "KW") {
                factoryName = "高雄廠";
              } else if (item.factoryId === "SZ") {
                factoryName = "蘇州廠";
              } else if (item.factoryId === "NJ") {
                factoryName = "南京廠";
              } else if (item.factoryId === "GZ") {
                factoryName = "廣州廠";
              } else if (item.factoryId === "VH") {
                factoryName = "越南義安廠";
              }
              let createTime = $fixDate(item.createTime);
              let declineDate = $fixDate(item.declineDate);
              let inquiryEndDate = $fixDate(item.inquiryEndDate);
              let requestDate = $fixDate(item.requestDate);
              return {
                ...item,
                factoryName,
                createTime: createTime,
                declineDate: declineDate,
                inquiryEndDate: inquiryEndDate,
                requestDate: requestDate,
                isPR: item.isPR ? "是" : "否",
              };
            });
            this.$refs.requestSearchBs4Table.page = params.pageIndex;
            vm.totalCount = response.data.totalCount;
            vm.requestQueryParam = val;

            let roleId = this.$userInfo.roleId;
            if (roleId.indexOf("採購") > -1) {
              // 是採購
              vm.isPurchase = true;
            } else {
              // 非採購
              vm.isPurchase = false;
            }
          }
        }
      });
    },

    // 詳細資訊
    detail(status, row) {
      //this.$store.dispatch('alertMessageModule/updateMessage', { message: '已成功登入', status: 'success' });

      if (status === "edit") {
        // 詳細資訊
        sessionStorage.setItem("requestMasterId", row.id);
        this.$router.push({
          path: "/Requestedit",
          query: { formStatus: "edit", requestMasterId: row.id },
        });
      } else if (status === "copy") {
        // 複製
        sessionStorage.setItem("requestMasterId", "");
        this.$router.push({
          path: "/Requestedit",
          query: { formStatus: "copy", requestMasterId: row.id },
        });
      }
    },

    // 作廢 Api
    finishInvalid(val) {
      const url = `${this.$baseApiUrl}/RequestMaster/VoidRequestMaster`;
      const param = { id: this.invalidId, rejectReason: val };

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        // console.log("作廢", response);
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage[0],
            type: "error",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          filter ? this.doSearchEvent(filter) : this.doSearchEvent();
        }
      });
    },

    // 退件 Api
    finishReject(val) {
      const url = `${this.$baseApiUrl}/RequestMaster/RejectRequestMaster`;
      const param = { id: this.rejectId, rejectReason: val };

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        // console.log("退件", response);
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage[0],
            type: "error",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          filter ? this.doSearchEvent(filter) : this.doSearchEvent();
        }
      });
    },

    // 重啟報價 Api
    restartRequest(id) {
      // console.log(id);
      const url = `${this.$baseApiUrl}/RequestMaster/RestartRequestMaster`;
      const param = { id: id };

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        // console.log("重啟報價", response);
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage[0],
            type: "error",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          filter ? this.doSearchEvent(filter) : this.doSearchEvent();
        }
      });
    },

    // 指定結案 Api
    closeCase(id) {
      // console.log(id);
      const url = `${this.$baseApiUrl}/RequestMaster/DesignatedRequestMaster`;
      const param = { id: id };

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        // console.log("指定結案", response);
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "警告",
            message: response.data.errorMessage[0],
            type: "warning",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "指定結案已完成",
            type: "success",
            duration: 5000,
          });

          filter ? this.doSearchEvent(filter) : this.doSearchEvent();
        }
      });
    },

    // 分頁搜尋
    onChangeQuery(queryParams) {
      let back = sessionStorage.getItem('Requestedit')
      let search = {};

      search = {
        ...search,
        ...this.requestSearchObj.filter,
      }

      search.pageSize = queryParams.per_page;

      if (back) {
          // 內頁返回時，用原本 this.trialProdQueryParam 的參數
          sessionStorage.removeItem('Requestedit')
      }else {
          // 使用底下按鈕
          search.pageIndex = queryParams.page;
      }

      this.doSearchEvent(search);
    },

    // 分頁中文資訊
    paginationInfoTwText(props) {
      const vm = this;

      let page = vm.$refs.requestSearchBs4Table.page;
      let pageCount = vm.$refs.requestSearchBs4Table.per_page;

      let startRecNo = 0;
      let endRecNo = 0;

      if(vm.totalCount && vm.totalCount > 0) {
          startRecNo = 1 + (page - 1 ) * pageCount;
          endRecNo = startRecNo + pageCount -1;
          if(endRecNo > vm.totalCount) {
              endRecNo = vm.totalCount ;
          }
          return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
      }else{
          return '無任何資料列';
      }  
    },

    // 需求附件 Api
    requireFileModal(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetail`;
      this.updateLoading(true);

      let params = {
        RequestMasterId: id,
      };

      vm.requireFileList = [];

      this.axios.get(api, { params }).then((response) => {
        // console.log("需求附件", response.data.requestDetails);
        this.updateLoading(false);
        if (response.data.requestDetails) {
          response.data.requestDetails.map((item, index) => {
            item.requestDetailFiles.map((file, fileIndex) => {
              vm.requireFileList.push({
                index: index + 1,
                productName: item.productName,
                spec: item.spec,
                brand: item.brand,
                productNo: item.productNo,
                fileIndex: fileIndex + 1,
                fileName: file.fileName,
                id: file.id,
              });
            });
          });
          $("#requireFileModal").modal("show");
        } else {
          $("#requireFileModal").modal("show");
        }
      });
    },

    // 下載 需求附件 Api
    downloadRequireFile(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/GetFile/${id}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        const filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    // 廠商附件 Api
    VendorFileModal(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetail`;
      this.updateLoading(true);

      let params = {
        RequestMasterId: id,
      };

      vm.vendorFileList = [];

      this.axios.get(api, { params }).then((response) => {
        // console.log("廠商附件", response.data.requestSupplierFiles);
        this.updateLoading(false);
        if (response.data.requestSupplierFiles) {
          response.data.requestSupplierFiles.map((item) => {
            vm.vendorFileList.push({
              ...item,
            });
          });
          $("#VendorFileModal").modal("show");
        } else {
          $("#VendorFileModal").modal("show");
        }
      });
    },

    // 下載 廠商附件 Api
    downloadVendorFile(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestSupplier/GetFile/${id}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        const filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    openPurchaseExceptionRemarks(row) {
      const vm = this;

      vm.tempRow = JSON.parse(JSON.stringify(row));

      $("#purchaseExceptionRemarksModal").modal("show");
    },
    savePurchaseExceptionRemarks() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/EditPurchaseExceptionMemo`;

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      if(vm.tempRow.purchaseExceptionMemo === null || vm.tempRow.purchaseExceptionMemo === '') {
        Notification({
          title: "提示",
          message: "您尚未輸入內容",
          type: "warning",
          duration: 5000,
        });

        return;
      }

      let params = {
        id: vm.tempRow.id,
        purchaseExceptionMemo: vm.tempRow.purchaseExceptionMemo,
      };

      vm.updateLoading(true);

      vm.axios.post(api, params).then((response) => {
        this.updateLoading(false);

        if(response.status === 200) {
          Notification({
            title: "成功",
            message: "儲存成功",
            type: "success",
            duration: 5000,
          });

          vm.tempRow = {
            purchaseExceptionMemo: null,
          };
          
          filter ? vm.doSearchEvent(filter) : vm.doSearchEvent();
        } else {
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
        
        $("#purchaseExceptionRemarksModal").modal("hide");
      });

    },

    openChangesInPurchasingResponsibilityModal(row) {
      const vm = this;
      
      vm.tempRow = JSON.parse(JSON.stringify(row));

      if(vm.tempRow) vm.getFactoryPurchase(vm.tempRow.factoryId);

      $("#changesInPurchasingResponsibilityModal").modal("show");
    },

    // 取得各廠採購人員清單
    getFactoryPurchase(factoryId) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/GetFactoryPurchase`;
      let params = { FactoryId: factoryId };

      this.axios.get(api, { params }).then((response) => {
        vm.FactoryPurchase = response.data;
      });
    },

    saveChangesInPurchasingResponsibility() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/EditPurchase`;

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      if(vm.tempRow.purchase === null || vm.tempRow.purchase === '') {
        Notification({
          title: "提示",
          message: "您尚未選擇擔當人員",
          type: "warning",
          duration: 5000,
        });

        return;
      }

      let params = {
        id: vm.tempRow.id,
        purchase: vm.tempRow.purchase,
      };

      vm.updateLoading(true);

      vm.axios.patch(api, params).then((response) => {
        this.updateLoading(false);

        if(response.status === 200) {
          Notification({
            title: "成功",
            message: "儲存成功",
            type: "success",
            duration: 5000,
          });

          vm.tempRow = {
            purchaseExceptionMemo: null,
          };
          
          filter ? vm.doSearchEvent(filter) : vm.doSearchEvent();
        } else {
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
        
        $("#changesInPurchasingResponsibilityModal").modal("hide");
      });

    },

    openChangesNumberOfInquiriesModal(row) {
      const vm = this;
      
      vm.tempRow = JSON.parse(JSON.stringify(row));

      $("#changesNumberOfInquiriesModal").modal("show");
    },
    //  檢核 詢價需求單(自採購擔當)參數，都滿足則回傳 true
    checkByPurchaseParam(param) {
      let chkFileds = "";

      if (param.inquiryCount) {
        chkFileds = {
          inquiryCount: "詢價家數需選擇",
        };
      } else {
        chkFileds = {
          inquiryCount: "詢價家數需選擇",
          inquiryCountReason: "說明原因需輸入",
        };
      }

      for (let fd in chkFileds) {
        let val = param[fd];
        if (val !== false && !val) {
          //無此參數資料
          this.$alert(chkFileds[fd], "警告", { type: "warning" });
          return false;
        }
      }
      
      if (
        param.inquiryCount &&
        param.requestSuppliers &&
        param.requestSuppliers.length < 2
      ) {
        this.$alert("報價廠商至少兩家", "警告", { type: "warning" });
        return false;
      }
      return true;
    },
    saveChangesNumberOfInquiries() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/EditInquiryCount`;

      const filter =
        this.$store.getters["requestModule/requestSearchObj"].filter;

      let params = {
        id: vm.tempRow.id,
        inquiryCount: vm.tempRow.inquiryCount,
        inquiryCountReason: vm.tempRow.inquiryCountReason,
      };

      if (!this.checkByPurchaseParam(params)) {
        return;
      }

      vm.updateLoading(true);

      vm.axios.patch(api, params).then((response) => {
        this.updateLoading(false);

        if(response.status === 200) {
          if(response.data.length > 0) {
            Notification({
              title: "失敗",
              message: response.data[0],
              type: "error",
              duration: 5000,
            });
          } else {
            Notification({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 5000,
            });
          }

          vm.tempRow = {
            purchaseExceptionMemo: null,
          };
          
          filter ? vm.doSearchEvent(filter) : vm.doSearchEvent();
        } else {
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
        
        $("#changesNumberOfInquiriesModal").modal("hide");
      });

    },

    requiredCss(src) {
      if (this.isEdit) {
        return src;
      } else {
        return src + " requiredCss";
      }
    },
  },
  computed: {
    ...mapGetters(["lang"]),
    ...mapGetters('requestModule', ['requestSearchObj']),

    isAdmin (){           
      return this.$isAdmin;
    },
    isPurchaserSuperior () {           
      return this.$isPurchaserSuperior;
    },
    isRequestOnly () {           
      return this.$isRequestOnly;
    },
    isAuditSuperior () {
      return this.$isAuditSuperior;
    },
    isRequestSystemUser () {
      return this.$isRequestSystemUser;
    },

    isPurchaser () {   //  採購人員
      let { funcNames } = this.$userInfo;

      return funcNames.some(str => str.includes('採購'));
    },
  },

  mounted() {
    const filter = this.$store.getters["requestModule/requestSearchObj"].filter;
    let { account, roleId, userFactory, accountName, funcNames } = this.$userInfo;

    let params = {};

    if (roleId.indexOf("採購") > -1 && 
      !funcNames.some(str => str.includes("採購主管")) &&
      !funcNames.some(str => str.includes("稽核主管")) &&
      !funcNames.some(str => str === "詢價")
    ) {  // 是採購
      params = {
        params,
        Factory: filter.Factory ? filter.Factory : (filter.Factory === "" ? "" : (userFactory ? userFactory : "")),
        Purchase: filter.Purchase ? filter.Purchase : (filter.Purchase === "" ? "" : (accountName ? accountName : "")),
        Status: filter.Status ? filter.Status : (filter.Status === "" ? "" : "需求單位已確認"),
      };
    } else if (roleId === "詢價") {   // 是詢價
      params = {
        ...params,
        Factory: filter.Factory ? filter.Factory : "",
      };
    } else {    // 非採購或詢價
      params = {
        ...params,
        Factory: filter.Factory ? filter.Factory : (filter.Factory === "" ? "" : (userFactory ? userFactory : "")),
      };
    }

    this.searchRequest(params);
  },
};
</script>
<style lang="scss" scoped>
table th:first-child {
  text-align: center;
  padding: 15px 5px;
}
.fileDownload {
  color: #409eff;
  cursor: pointer;
}
.btn-gray {
  background-color: gray;
  color: white;
}
.btn-warning {
  color: #fff;
}

.btn-blue {
  color: #fff !important;
  font-size: .85em;
  background: #343b55;
  border-radius: 6px;
}

.btn-purple {
  background-color: #7020e7;
  color: white;
}

.modal-dialog-sm {
  max-width: 500px !important;
}

.ask_merchant {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;

  > p {
    margin-right: 1rem;
    margin-bottom: 0;
  }

  > input {
    margin: 0 0.5rem;
  }

  > span {
    margin: 0 0.5rem;
  }

  > div {
    margin: 0 0.5rem;
  }
}

.requiredCss::before {
  content: "*";
  color: #f26161;
  font-weight: bolder;
  margin-bottom: 6px;
}
</style>